import React from "react";
import { LargeText, SmallButton, Foot } from "../Hero/Hero";

const Footer = () => {
  return (
    <>
      <Foot>
        <LargeText>Project for Hackathon</LargeText>
      </Foot>
    </>
  );
};

export default Footer;
